module.exports = __webpack_public_path__ + "static/media/logoorange.4a972825.png";